import dashboardIcon from "../images/new-images/dark-nav-icon.png";
import reportsIcon from "../images/new-images/reports-nav-icon.svg";
import analysis from "../images/new-images/swot-nav-icon.svg";
import dashboardLightImage from "../images/new-images/light-nav-images/dashboard-nav-icon.svg";
import reportsLightImage from "../images/new-images/light-nav-images/report-nav-icon.svg";
import analysisLightImage from "../images/new-images/light-nav-images/Swot-White.svg";
import slide1 from "../images/new-images/modal-images/self-assessment.png";
import slide2 from "../images/new-images/modal-images/respondants.png";
import slide3 from "../images/new-images/modal-images/report.png";
import slide4 from "../images/new-images/modal-images/step-1.png";
import slide5 from "../images/new-images/modal-images/target.png";
import slide6 from "../images/new-images/modal-images/sentiment.png";

export const API_URLS = {
    Respondent_Relation_Accessor_Dropdown: ({ sellerId, orgId }) => `/users/organisation/assessor/group/list/edit/${sellerId}/${orgId}/`

}
export const ROUTES = {
    dashboard: "/new/app/dashBoard",
    reports: "/new/app/reports/:id",
    downloadreports: "/new/app/reportdownload/:id/:participant__id",
    createProfile: "/new/app/createprofile",
    editProfile: "/new/app/EditProfile",
    welcome: "/new/app/welcome/:instrument_id/:id/:organisation/:seller/:participant__id/:instrument__is_multi_rater/:assessmentCompletedCount/:assessmentType",
    welcomeInvitations: "/new/app/welcomeInvitations",
    selfAssessment: "/new/app/selfassessment/:instrument_id/:id/:organisation/:seller/:participant__id/:instrument__is_multi_rater/:assessmentCompletedCount/:assessmentType",
    invitations: '/new/app/invitations/:id/:participant__id/:instrument__is_multi_rater',
    submitAssessment: '/new/app/submitassessment/:sentRespondantsId/:idOfParticipant/:submitAssessment/:isMultiRater',
    beginQuestionnaire: "/new/app/questionnaire/:instrument_id/:id/:organisation/:seller/:participant__id/:instrument__is_multi_rater/:assessmentCompletedCount/:assessmentType",
    CompletedAssessmentScreen: "/new/app/completedassessment/:id/:participant__id/:isMultiRater/:min_batch_respondents",
    MyWorksheet: '/new/app/MyWorksheet/:id',
    Worksheets: '/new/app/Worksheets/:orientation__orientation_name',
    ManageWorkSheet: '/new/app/ManageWorkSheet',
    Emptydashboard: '/new/app/emptydashboard/:assessmentType',
    compareAssesment: "/new/app/compare-assessment",
    comparedAssessmentList:"/new/app/assessment",
    comparedAssessmentReport:"/new/app/assessment-report",
}

export const SIDE_NAV_ITEMS = [{
    id: "dashboard",
    link: ROUTES.dashboard,
    linkName: "Dashboard",
    navImage: dashboardIcon,
    navLightImage: dashboardLightImage
}, {
    id: "reports",
    link: ROUTES.reports,
    linkName: "Reports",
    navImage: reportsIcon,
    navLightImage: reportsLightImage

}, 
// {
//     id: "analysis",
//     link: ROUTES.analysis,
//     linkName: "Swot Analysis",
//     navImage: analysis,
//     navLightImage: analysisLightImage

// }

]
export const ADMIN_SIDE_NAV_ITEMS = [{
    id: "dashboard",
    link: ROUTES.dashboard,
    linkName: "Dashboard",
    navImage: dashboardIcon,
    navLightImage: dashboardLightImage
},  


]

export const profileNav = [{
    id: "dashboard",
    link: ROUTES.dashboard,
    linkName: "Dashboard",
    navImage: dashboardIcon,
    navLightImage: dashboardLightImage
}, {
    id: "reports",
    link: ROUTES.reports,
    linkName: "Reports",
    navImage: reportsIcon,
    navLightImage: reportsLightImage

}, {
    id: "analysis",
    link: ROUTES.analysis,
    linkName: "Swot Analysis",
    navImage: analysis,
    navLightImage: analysisLightImage

}]

export const sliderData = [{
        sliderStep: "Step 1",
        sliderImage: slide1,
        sliderHeading: "Self-Assessment",
        sliderParagraph: "Assess yourself by responding to a set of 30 questions. Allow yourself 4-5 minutes and bingo, you’re done!",
    },
    {
        sliderStep: "Step 2",
        sliderImage: slide2,
        sliderHeading: "Respondents",
        sliderParagraph: "Invite as many people as you like to assess you, and track their progress. Follow up with them, using one-click auto-reminders",
    },
    {
        sliderStep: "Step 3",
        sliderImage: slide3,
        sliderHeading: "Reports",
        sliderParagraph: " When you satisfy the minimum respondent criteria, submit your assessment to get your Style-wise and/or 360-degree report (based on what you signed up for)",
    },
    {
        sliderStep: "Things to Keep in Mind",
        sliderHeading: "# 1",
        sliderImage: slide4,
        sliderParagraph: "Respond to all questions in one go",
    },
    {
        sliderStep: "Things to Keep in Mind",
        sliderHeading: "# 2",
        sliderImage: slide5,
        sliderParagraph: "Be accurate in your responses",
    },
    {
        sliderStep: "Things to Keep in Mind",
        sliderHeading: "# 3",
        sliderImage: slide6,
        sliderParagraph: "Avoid neutral responses as much as possible",
    },
];


// WEBPACK FOOTER //
// ./src/new/api-constant.js